import React from 'react'
import { AppImages } from '@/app'
import { Image } from '@/components/Image'

export function PersonaBackground() {
  return (
    <>
      <Image source={AppImages.blueBg} resizeMode="cover" style={[{ position: 'absolute', width: '100%', height: 'auto', right: 0, aspectRatio: 1.7 }]}/>
      <Image
        source={AppImages.personaCard}
        resizeMode="contain"
        style={[{ position: 'absolute', height: '100%', opacity: 0.5, right: 0 }]}
      />
    </>
  )
}
